import { InputLabel } from '@mui/material';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';
import LinesIcon from '../../../components/Icons/LinesIcon';

const ForecastName = () => {
  const { control } = useFormContext();

  return (
    <Paper className='px-3 py-4 print:hidden'>
      <div className='flex flex-col gap-3'>
        <div className='flex items-center relative'>
          <LinesIcon className='text-[#141B34]' />
          <InputLabel sx={{ marginBottom: '4px', fontSize: '18px' }} htmlFor='forecast-name-input'>
            Forecast Name
          </InputLabel>
        </div>
        <Controller
          control={control}
          name='forecastName'
          rules={{
            required: {
              value: true,
              message: 'Forecast Name is required.',
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              id='forecast-name-input'
              fullWidth
              placeholder='New-York Forecast'
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </div>
    </Paper>
  );
};

export default ForecastName;
